import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { JuridicalPersonProps, JuridicalPersonUpdateProps, TJuridicalPersonsState } from '../../types'
import { organizationService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseJuridicalPersons } from './utils'
import { selectors } from './selectors'
import { juridicalPersonsAdapter } from './adapter'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'

const name = 'juridicalPersons'

const initialState: TJuridicalPersonsState = {
    ...juridicalPersonsAdapter.getInitialState(),
    isFetching: false,
    totalItems: 0,
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async (params: FetchCreatedAtParams & FetchCollectionParams | undefined) => {
        const order = params?.order  || {'order[name]': 'asc'}

        return parseJuridicalPersons(await organizationService.fetchJuridicalPersons({
            pagination: params?.pagination,
            page: params?.page,
            perPage: params?.perPage,
            ...order
        }))
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (data: JuridicalPersonProps) => {
        return await organizationService.createJuridicalPerson(data)
    },
    {
        serializeError: parseHttpError
    }
)

const update = createAsyncThunk(
    `${name}/create`,
    async (data: JuridicalPersonUpdateProps) => {
        return await organizationService.updateJuridicalPerson(data)
    },
    {
        serializeError: parseHttpError
    }
)

const remove = createAsyncThunk(
    `${name}/remove`,
    async (id: string) => {
        return await organizationService.removeJuridicalPerson(id)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                state.totalItems = action.payload.totalItems
                juridicalPersonsAdapter.setAll(state, action.payload.entities)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const juridicalPersons = {
    name: slice.name,
    actions: {
        fetch,
        create,
        update,
        remove,
    },
    reducer: slice.reducer,
    selectors,
}